import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormGroup, FormControl, Validators, NgForm } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ContactService } from "../../services/strapi/contact.service";
import { InfluxService } from "../../services/api/influx.service";

@Component({
  selector: "app-contact-edit-popup",
  templateUrl: "./contact-edit-popup.component.html",
  styleUrls: ["./contact-edit-popup.component.scss"],
})
export class ContactEditPopupComponent implements OnInit {
  item: {
    name: string | null;
    email: string | null;
    phone: string | null;
    line_user_id?: string;
    line_display_name?: string;
  } = {
    name: null,
    email: null,
    phone: null,
  };
  @Input() isEdit: boolean;
  @Input() isNeoContact: boolean = false;
  @Input() contactData: any;
  @Output() onSave: EventEmitter<any> = new EventEmitter();
  @ViewChild("dataEntryForm") dataEntryForm: NgForm;
  lineUsers;
  constructor(
    public modal: NgbActiveModal,
    private contactService: ContactService,
    public activeModal: NgbActiveModal,
    private adminService: InfluxService
  ) {}

  ngOnInit(): void {
    this.getLineUsers();
  }

  getLineUsers() {
    this.adminService.getLineUsers().subscribe({
      next: (data) => {
        console.log(data);
        this.lineUsers = data;
      },
      error: (error) => {
        console.error("Error:", error);
      },
    });
  }

  onSubmit(): void {
    if (this.dataEntryForm.valid) {
      const api = this.isEdit
        ? this.contactService.updateContact(this.item)
        : this.contactService.addContact(this.item);
      api.subscribe((res) => {
        this.onSave.emit(res.data);
      });
    }
  }

  onSubmitNeoContact(): void {
    if (this.dataEntryForm.valid) {
      const selectedUser = this.lineUsers.find(
        (user) => user.userId === this.item.line_user_id
      );
      if (selectedUser) {
        this.item.line_display_name = selectedUser.displayName;
      }

      const api = this.isEdit
        ? this.contactService.updateNeoContact(this.item)
        : this.contactService.addNeoContact(this.item);
      api.subscribe((res) => {
        this.onSave.emit(res.data);
      });
    }
  }

  closeModal(update: boolean = false): void {
    this.activeModal.dismiss(false);
    return;
  }
}
